export default function Work() {
    return (
        <div class="whole-experience">
            <h1>Work</h1>
            <div class="experience-container">
        <div class="experience">
            <div class="experience-description">
                <h2>LA-Tech Academy Coach</h2>
                <p>- 100+ hours instructing the youth of tech about Cybersecurity and Cloud Concepts</p>
                <p>- Led 40+ scholars to expand economic opportunities for LA’s under-served communities</p>
                <p>- Oversaw scholars in rigorous curriculum & student-led projects to set up EC2/virtual machines</p>
            </div>
            <div class="experience-image">
                <img src="https://media.licdn.com/dms/image/v2/D560BAQEhw6Es-Aslzg/company-logo_100_100/company-logo_100_100/0/1719872392143?e=1734566400&v=beta&t=yjsvNQ-1gIT89fZOKMq6rdltyq2Fd8YN9jtmxdJVmR4" alt=''/>
            </div>
        </div>

        <div class="experience">
            <div class="experience-description">
                <h2>Assure-US Peer Mentor</h2>
                <p>- Guided 30+ students to research uses of data science, data structure and algorithms on csv data</p>
                <p>- Analyzed the best trading period in stocks using methods like Greedy and Divide-and-conquer</p>
                <p>- Instructed students on the basics of python and jupyter notebook to efficiently format data</p>
            </div>
            <div class="experience-image">
                <img src="https://media.licdn.com/dms/image/v2/C4E0BAQG0C1xsD27VRA/company-logo_100_100/company-logo_100_100/0/1630584092659?e=1734566400&v=beta&t=8KtTax4YiWKgyCGVugE4ik68-Wzvifb_kC9oBhRTt3s" alt=''/>
            </div>
        </div>

        <div class="experience">
            <div class="experience-description">
                <h2>Code Coach at theCoderSchool</h2>
                <p>- Led groups of 10+ students to create programs through the use of scratch in hourly sessions</p>
                <p>- Constructed lesson plans for students individually and worked with up to 6 different languages</p>
                <p>- Encouraged children by making connections between children’s interests and coding concepts</p>
            </div>
            <div class="experience-image">
                <img src="https://media.licdn.com/dms/image/v2/C510BAQH2SniJjbph3Q/company-logo_100_100/company-logo_100_100/0/1631364103877?e=1734566400&v=beta&t=TSjscr0cWXu9Jh3ZEez9rixxg8o9BXrkyxUa8VbL7LI" alt=''/>
            </div>
        </div>

        <div class="experience">
            <div class="experience-description">
                <h2>Student Research Assistant</h2>
                <p>- Utilized a GPS module for a campus delivery robot for the Army Research Office</p>
                <p>- Explored the creation of a JavaScript program to create directions from point A to B</p>
                <p>- Programmed Raspberry PI to connect with server via websockets</p>
            </div>
            <div class="experience-image">
                <img src="https://media.licdn.com/dms/image/v2/C4E0BAQG0C1xsD27VRA/company-logo_100_100/company-logo_100_100/0/1630584092659?e=1734566400&v=beta&t=8KtTax4YiWKgyCGVugE4ik68-Wzvifb_kC9oBhRTt3s" alt=''/>
            </div>
        </div>
    </div>
        </div>
        )
}